import React, { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import TopShape from '../../images/ft-bg.png'
import logo from '../../images/product/ethiopiasheger.png'
import Btnicon from '../../images/pointer.svg'
import { useNavigate } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const navigate= useNavigate();

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(String(email).toLowerCase());
    };


    const  handlegishen=()=>{
        navigate('https://gishenmariam.com')
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateEmail(email)) {
            setError('');
            console.log('Email is valid:', email);
        } else {
            setError('Please enter a valid email address.');
        }
    };

    const { FooterShape = true } = props

    return (
        <div className={'' + props.hclass}>
            {FooterShape && (
                <div className="footer-shape">
                    <img src={TopShape} alt="" />
                </div>
            )}
            <footer className="wpo-site-footer">
                <div className="wpo-upper-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="widget about-widget">
                                    <div className="logo widget-title">
                                        <img src={logo} alt=""  width="100px" height='70px' className="rounded-circle"/>
                                    </div>
                                    <p>We provide authentic Ethiopian catering services, fresh injera, quality spices and ingredients, money transfer services, and household essentials to our community.</p>
                                    
                                </div>
                            </div>
                            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="widget link-widget">
                                    <div className="widget-title">
                                        <h3>Our Services</h3>
                                    </div>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/catering">Catering Services</Link></li>
                                        <li><Link onClick={ClickHandler} to="/injera">Fresh Injera</Link></li>
                                        <li><Link onClick={ClickHandler} to="/spices">Spices & Ingredients</Link></li>
                                        <li><Link onClick={ClickHandler} to="/money-transfer">Money Transfer</Link></li>
                                        <li><Link onClick={ClickHandler} to="/household">Household Needs</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="widget wpo-contact-widget">
                                    <div className="widget-title">
                                        <h3>Contact Us</h3>
                                    </div>
                                    <div className="contact-ft">
                                        <ul>
                                            <li><i className="fi flaticon-placeholder"></i>14455 Richmond Highway<br />
                                                Woodbridge, VA 22191<br />
                                                Suite #4
                                            </li>
                                            <li><i className="fi flaticon-phone-call"></i>571 331 2344<br />571 408 4956</li>
                                            <li><i className="fi flaticon-email"></i>gullate45@gmail.com</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="widget newsletter-widget">
                                    <div className="widget-title">
                                        <h3>Newsletter</h3>
                                    </div>
                                    <p>Subscribe to get updates on our special offers and new services.</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="input-1">
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Email Address *"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>
                                        {error && <div className="error-message" style={{ color: 'red' }}>{error}</div>}
                                        <div className="submit clearfix">
                                            <button type="submit">
                                                <i>
                                                    <img src={Btnicon} alt="Submit" />
                                                </i>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wpo-lower-footer">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 col-12">
                                <p className="copyright">Copyright &copy;<span>2025</span>
                                    <span className="copyright-icon">|</span> All Rights Reserved.
                                </p>
                            </div>
                            <div className="col-lg-6 col-md-12 col-12">
  <p className="link">
    <Link onClick={handlegishen} to="https://gishenmariam.com">gishenmariam web solutions</Link> 
    <span> || </span> 
    <Link onClick={ClickHandler} to="/">2025 </Link>
  </p>
  <div>
   
  </div>
</div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer;